import { useQueryUserBillingInfo } from '@/hooks/query/useQueryUserBillingInfo';
import useReverseTrial from '@/hooks/useReverseTrial';
import { SubscriptionTier } from '@heidi/schema/ml-scribe';
import { useMemo } from 'react';

/**
 * ButtonClicked context for downgrade / cancel billing modals (aligned with pricing-plans modal CTAs).
 */
export function useDowngradeFlowButtonAnalyticsProps() {
  const { data: billingInfo } = useQueryUserBillingInfo();
  const legacyTier = billingInfo?.tier;
  const currentPlan = billingInfo?.new_product_tier;
  const { isInReverseTrial, isFakeClinicianTrial } = useReverseTrial();

  return useMemo(() => {
    const currentPlanValue = currentPlan ?? legacyTier;
    return {
      ...(currentPlanValue !== undefined && { current_plan: currentPlanValue }),
      target_plan: SubscriptionTier.FREE,
      is_reverse_trial: isInReverseTrial,
      is_fake_trial: isFakeClinicianTrial,
    };
  }, [currentPlan, legacyTier, isInReverseTrial, isFakeClinicianTrial]);
}
